export default {
  minivariant: state => state.minivariant
};
